export default "__VITE_ASSET__HcRUGPCu__"